import { vaultPostRequest } from '../helpers';
import type { IDeployResponse } from './deploy-response';
import { deployResponseSchema } from './deploy-response';

export async function deployApi(baseUrl?: string): Promise<IDeployResponse> {
  return vaultPostRequest({ path: '/deploy', body: {}, schema: deployResponseSchema, baseUrl });
}
